import { outputTypeEnum } from "kubb";
import { PageHeadingBlock } from "../../components/Theme/heading";
import { useCreateReportExecution } from "../../hooks/createEntity.tsx";
import { useRequiredSelectedCompany } from "../../hooks/useCompany";
import { useSelectedScheme } from "../../hooks/useScheme";
import ReportExecutionCreator from "./executions/ReportExecutionCreator";
import ReportExecutionList from "./executions/ReportExecutionList";

function BillingReportPage() {
  const company = useRequiredSelectedCompany();
  const scheme = useSelectedScheme();

  const create = useCreateReportExecution(company.company_id);
  return (
    <>
      <PageHeadingBlock>Export Billing Report</PageHeadingBlock>
      <ReportExecutionCreator
        company={company}
        create={create.update}
        createError={create.error}
        outputTypeFilter={[outputTypeEnum.BILLING]}
      />
      <ReportExecutionList
        company_id={company.company_id}
        scheme_id={scheme?.scheme_id}
        params={{ format: [outputTypeEnum.BILLING] }}
        cursor={{ max_items: 15 }}
      />
    </>
  );
}

export default BillingReportPage;
